import PlatformRewardsOverview from "@/components/RewardsOverview/PlatformRewardsOverview";
import React from "react";
import ReactDOM from "react-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

function mountPlatformRewardsOverview() {
  const el = document.getElementById("rewards-overview");
  const propsScript = document.getElementById("rewards-overview-props");

  if (el && !el.dataset.reactMounted && propsScript) {
    try {
      const props = JSON.parse(propsScript.textContent || "{}");
      ReactDOM.render(React.createElement(PlatformRewardsOverview, props), el);
      el.dataset.reactMounted = "true";
    } catch (e) {
      console.error("Failed to parse props JSON:", e);
    }
  }
}

document.addEventListener("turbo:render", mountPlatformRewardsOverview);
document.addEventListener("DOMContentLoaded", mountPlatformRewardsOverview);
mountPlatformRewardsOverview();
